import { DOCUMENT } from '@angular/common';
import { Component, Inject } from '@angular/core';

@Component({
  selector: 'app-page-header',
  templateUrl: './page-header.component.html',
  styleUrls: ['./page-header.component.scss']
})
export class PageHeaderComponent {
  constructor( @Inject(DOCUMENT) private document:Document,){
    
  }

  toggleSideMenu(){
    // Dispatch custom event for sidebar toggle
    const event = new CustomEvent('sidebarToggle', { bubbles: true });
    this.document.dispatchEvent(event);
    
    // Fallback: Direct DOM manipulation for backward compatibility
    let sidebar = this.document.querySelector('.sidebar');
    if (sidebar) {
      const isMobile = window.innerWidth <= 768;
      if (isMobile) {
        sidebar.classList.toggle('show');
      }
    }
  }
}
